export default __webpack_public_path__ + "application.7dc213a4864131dd7f2f.svg";